import { Stack } from '@asgard/ui-library';
import Page from 'components/layout/Page';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { createGlobalStyle } from 'styled-components';
import { APP_URLS } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import TalentCV from './cv/TalentCV';
import { TalentHero } from './hero/TalentHero';
import TalentOffers from './offers/TalentOffers';
import TalentRecruiting from './recruiting/TalentRecruiting';
import TalentTools from './tools/TalentTools';

export const TalentPage: React.FC = () => {
  const { t } = useI18n('talent-new');

  usePageTrack('Landing - Page Loaded');

  const TalentGlobalStyles = createGlobalStyle`
  a > span > span {
    white-space: wrap;
  }`;

  return (
    <>
      <TalentGlobalStyles />
      <HeadMetadata
        title={t('talent-new.page_title')}
        desc={t('talent-new.page_description')}
        url={APP_URLS.talent}
        imgUrl={`${getPublicPath('/images/cards/card_talent_new.png')}`}
        indexable={true}
      />
      <Page hasScrollTop pageVariant="midnight_light">
        <Stack direction="column" gap="3xl">
          <TalentHero />
          <TalentCV />
          <TalentOffers />
          <TalentRecruiting />
          <TalentTools />
        </Stack>
      </Page>
    </>
  );
};
